import React, {useState, useCallback, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {Typography, Grid, Button, Avatar, Slide, CircularProgress, IconButton, Modal, Snackbar, Paper, InputBase, Slider, TextareaAutosize} from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import StarIcon from '@material-ui/icons/Star';
import FavoriteIcon from '@material-ui/icons/Favorite';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';
import SearchIcon from '@material-ui/icons/Search';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import ShareIcon from '@material-ui/icons/Share';
import DeleteIcon from '@material-ui/icons/Delete';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import EditIcon from '@material-ui/icons/Edit';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import EditAccountModal from '../../modals/EditAccountModal';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Resizer from "react-image-file-resizer";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { firestore, storage } from '../../../config/fbConfig';
import firebase from 'firebase';
import BusinessCardModal from '../../modals/BusinessCardModal';
import ScheduleProModal from '../../modals/ScheduleProModal';
import Sliderr from './Account/proProfile/Slider'
import SimpleBarReact from 'simplebar-react';
import "simplebar/src/simplebar.css";
import ServiceCard from '../../appointments/ServiceCard';
import { useHistory } from "react-router";
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import LoginModal from '../../modals/LoginModal';
import BookAppointmentModal from '../../modals/BookAppointmentModal';
import EditSocialMediaModal from '../../modals/EditSocialMediaModal';
import { getOrientation } from 'get-orientation/browser'
import { getCroppedImg, getRotatedImage } from '../../modals/canvasUtils'
import Cropper from 'react-easy-crop'
import ReportModal from '../../modals/ReportModal';
import { Close } from '@material-ui/icons';


const ORIENTATION_TO_ANGLE = {
  '3': 180,
  '6': 90,
  '8': -90,
}

const { ms, s, m, h, d } = require('time-convert')




const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
      vpBtn:{
        margin:'auto',
        textAlign:'center',
        '&:hover': {
          cursor: 'pointer',
        },
      },
      gridList: {
        width: 'inherit',
        height: 450,
      },
      icon: {
        color: 'rgba(255, 255, 255, 0.54)',
      },
      section: {
        '&:hover': {
          cursor:'pointer'
        }
      },
      
      contactAv:{
        "&:hover": {
          width:38,
          height:38,
          cursor:'pointer',
        },
      },
      wrapper: {
        height: '100%',
        width: 'fit-content',
        position: 'relative',
      },
      buttonProgress: {
        color: theme.palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
      },
      cropContainer: {
        position: 'relative',
        width: '100%',
        height: 200,
        background: '#333',
        [theme.breakpoints.up('sm')]: {
          height: 400,
        },
      },
      cropButton: {
        flexShrink: 0,
        marginLeft: 16,
      },
      controls: {
        width:'100%',
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        [theme.breakpoints.up('sm')]: {
          flexDirection: 'row',
          alignItems: 'center',
        },
      },
      sliderContainer: {
        display: 'flex',
        flex: '1',
        alignItems: 'center',
      },
      sliderLabel: {
        [theme.breakpoints.down('xs')]: {
          minWidth: 65,
        },
      },
      slider: {
        padding: '22px 0px',
        marginLeft: 16,
        [theme.breakpoints.up('sm')]: {
          flexDirection: 'row',
          alignItems: 'center',
          margin: '0 16px',
        },
      },     
  }));

  const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      600,
      600,
      "JPEG",
      80,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });

  function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
  }

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }


  const dataURIToBlob = (dataURI) => {
    const splitDataURI = dataURI.split(",");
    const byteString =
      splitDataURI[0].indexOf("base64") >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(":")[1].split(";")[0];
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
    return new Blob([ia], { type: mimeString });
  };


function ProProfile(props) {
  const { width, currentUser, userData } = props;
  const history = useHistory();
  const [pro, setPro] = useState({})
  const [editAcctModalOpen, setEditAcctModalOpen] = useState(false)
  const [editSMModalOpen, setEditSMModalOpen] = useState(false)
  const [openedImage, setOpenedImage] = useState('')
  const [imageModalOpen, setImageModalOpen] =useState(false)
  const [bcModalOpen, setBcModalOpen] =useState(false)
  const [scheduleOpen, setScheduleOpen] =useState(false)
  const [cancelationModal, setCancelationModal] =useState(false)
  const [cancelationPolicy, setCancelationPolicy] =useState('')
  const [editCancelation, setEditCancelation] =useState(false)
  const [reportModalOpen, setReportModalOpen] =useState(false)
  // const [newImageUrl, setNewImage] = useState('')
  const [openSuccess, setOpenSuccess] = useState(false)
  const [showLoginModal, setShowLoginModal] = useState(false)
  const [serviceSearch, setServiceSearch] = useState('')
  const [reviews, setReviews] = useState([])
  const [openErr, setOpenErr] = useState()
  const fileInput = useRef();
  const [imageLoading, setImageLoading] = useState(false);
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const classes = useStyles();
  const [copied, setCopied] = useState(false)
  const [transition, setTransition] = useState(undefined);
  const severity = ["error", "success"]
  const services = pro.services
  const numOfAppts = Math.abs(pro.apptsCompleted) > 999 ? Math.sign(pro.apptsCompleted)*((Math.abs(pro.apptsCompleted)/1000).toFixed(1)) + 'k' : Math.sign(pro.apptsCompleted)*Math.abs(pro.apptsCompleted)

  const [selectedService, setSelectedService] = useState(null)
  const [bookingModalOpen, setBookingModalOpen] = useState(false)

  const [imageSrc, setImageSrc] = React.useState(null)
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [rotation, setRotation] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [croppedImage, setCroppedImage] = useState(null)


  const imageHeight = (width === 'xs') ? 220 : (width === 'md') ? 400 : 500
  const h1 = (width === 'xs' || width === 'sm') ? 22 : 30
  const h2 = (width === 'xs' || width === 'sm') ? 14 : 22
  const text = (width === 'xs' || width === 'sm') ? 10 : 16
  const textColor = (width === 'xs') ? 'black' : 'white'
  const colsAmt = (width === 'xs' || width === 'sm') ? 2 : 3
  const backgroundFlex = (width === 'xs' || width === 'sm') ? '0 0 120px' : '0 0 200px'
  const bottomFlex = (width === 'xs' || width === 'sm') ? '1 0 60px' : '1 0 100px'
  const avatarSize = (width === 'xs' || width === 'sm') ? 60 : 90
  const infoHeight = (width === 'xs' || width === 'sm') ? 80 : 100
  const avatarTop = (width === 'xs' || width === 'sm') ? '60px' : '80px'
  const avatarLeft = (width === 'xs' || width === 'sm') ? '20px' : '40px'
  const editBtnTop = (width === 'xs' || width === 'sm') ? '170px' : '215px'
  const onlineTop = (width === 'xs' || width === 'sm') ? '55px' : '75px'
  const onlineLeft = (width === 'xs' || width === 'sm') ? '60px' : '85px'
  const textPadding = (width === 'xs' || width === 'sm') ? 10 : 0

  const size = (width === 'xs' || width === 'sm') ? 310 : 500
  const colsHgt = (width === 'md' || width === 'lg' || width === 'xl') ? 280 : 180
  const addTop = width === 'xs' ? 10 : null
  const addBottom = width !== 'xs' ? 10 : null
  const borderRgt = width <= 'lg' ? '1px solid grey' : 'none'
  const borderBtm = width <= 'lg' ? 'none' : '1px solid grey'
  const padding = (width === 'xs' || width === 'sm') ? '0px 10%' : '0px 15%'
  const barWidth = (width === 'xs' || width === 'sm') ? 45 : 70
  const paddingRgt = width === 'xs' ? 12 : 0
  // const xs = currentUser === null ? 11 : 11
  const sorter = {"mon": 1, "tue": 2, "wed": 3, "thu": 4, "fri": 5, "sat": 6, "sun": 7}
  
  const path = window.location.pathname.split('/')
  const pathName = path[3]

  const handleEditAcctModal = () => {
    setEditAcctModalOpen(!editAcctModalOpen)
}

  const handleReportModalOpen = () => {
    setReportModalOpen(!reportModalOpen)
}

  const handleEditCP = () => {
    setEditCancelation(!editCancelation)
}

  const handleSaveCP = () => {
    var userDocRef = firestore.collection(userData.collection).doc(userData.userId)

	userDocRef.update({
		cancelationPolicy: cancelationPolicy
	})
	.then(() => {
		setEditCancelation(false)
		setCancelationModal(!cancelationModal)
	})
}

  const handleCancelationModal = () => {
    setCancelationModal(!cancelationModal)
}

  const handleEditSMModal = () => {
    setEditSMModalOpen(!editSMModalOpen)
}

const handleClick = (Transition) => () => {
  setTransition(() => Transition);
  setCopied(true);
  setTimeout(() => {setCopied(false)}, 1500);
};

const handleOpenImage = (e) => {
  setOpenedImage(e.target.src)
  setImageModalOpen(!imageModalOpen)
}
const handleOpenBizCard = (e) => {
  setOpenedImage(e.target.src)
  setBcModalOpen(!bcModalOpen)
}
const handleOpenSchedule = (e) => {
  setScheduleOpen(!scheduleOpen)
}

const handleCloseImage = () => {
  setOpenedImage('')
  setImageModalOpen(!imageModalOpen)
}

const handleAddFavorite = () => {
  var userDocRef = firestore.collection(userData.collection).doc(userData.userId)

  userDocRef.update({
    favorites: firebase.firestore.FieldValue.arrayUnion(pro.email)
})
.then(() => {
    window.location.reload()
})
}

const handleRemoveFavorite = () => {
  var userDocRef = firestore.collection(userData.collection).doc(userData.userId)

  userDocRef.update({
    favorites: firebase.firestore.FieldValue.arrayRemove(pro.email)
})
.then(() => {
    window.location.reload()
})
}


const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
  setCroppedAreaPixels(croppedAreaPixels)
}, [])

const uploadCroppedImage = useCallback(async () => {
  try {
    const croppedImage = await getCroppedImg(
      imageSrc,
      croppedAreaPixels,
      rotation
    )

    var xhr = new XMLHttpRequest();
    xhr.open('GET', `${croppedImage}`, true);
    xhr.responseType = 'blob';
    xhr.onload = function(e) {
      if (this.status === 200) {
        var myBlob = this.response;
        // myBlob is now the blob that the object URL pointed to.
          
            let fileurl = ''
            var uploadTask = storage.ref(`ProInfo/${userData.email}-${userData.firstName}-${userData.lastName}/images/works/${pro.images.works.length+1}`).put(myBlob)
            uploadTask.on('state_changed', 
              (snapshot) => {
                //Handle progress...
                setImageLoading(true)
              }, 
              (error) => {
                // Handle unsuccessful uploads...
              }, 
              async () => {
                // Handle successful uploads on complete...
                await uploadTask.snapshot.ref.getDownloadURL().then( async (url) => {
                  fileurl = url
                  // console.log('File available at', fileurl)
                  setImageLoading(false)
                  closeModal()
                })
                .then(() => {
                  var userRef = firestore.collection(userData.collection).doc(userData.userId)
                  return userRef.update({
                    "images.works": firebase.firestore.FieldValue.arrayUnion(fileurl)
                  })
                  .then(() => {
                      setOpenSuccess(!openSuccess)
                  })
                  .catch((error) => {
                      console.error("Error updating document: ", error);
                      setOpenErr(!openErr)
                  });
                });
              }
            )
          
      }
    };
    xhr.send();

    // console.log(croppedImage)
    setCroppedImage(croppedImage)


  } catch (e) {
    console.error(e)
  }
}, [imageSrc, croppedAreaPixels, rotation, userData, pro, openErr, openSuccess])

const onFileChange = async (e) => {
  if (e.target.files && e.target.files.length > 0) {
    const file = e.target.files[0]
    let imageDataUrl = await readFile(file)

    // apply rotation if needed
    const orientation = await getOrientation(file)
    const rotation = ORIENTATION_TO_ANGLE[orientation]
    if (rotation) {
      imageDataUrl = await getRotatedImage(imageDataUrl, rotation)
    }

    setImageSrc(imageDataUrl)
  }
}


const select = () => {
    fileInput.current.click()
  }   

  const closeModal = () => {
    setImageSrc(null)
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
    setOpenErr(false);
  };

  const handleCloseModal = () => {
    setShowLoginModal(false);
};

const handleBookingModalOpen = () => {
  setBookingModalOpen(!bookingModalOpen)
}


  useEffect(() => {
    firestore.collection("professionals").where("url", "==", pathName)
    .onSnapshot((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            setPro(doc.data());
        }, (error) => {
              // console.log("Error getting documents: ", error);
          }
        
        );
    })

    if(pro.firstName){
      firestore.collection('professionals').doc(pro.userId).collection('reviews')
      .orderBy("review.createdAt", "desc")
      .onSnapshot((snapshot) => {
       setReviews(snapshot.docs.map((doc) => doc.data()))
      //  console.log('this is happening')
    })
    }

  }, [selectedService, pro.firstName])


  


  return (
      <>
      {pro.title && 
      <Grid container style={{height:'95vh', display:'flex', justifyContent:'center', alignItems:'center', paddingRight:0}}>
      {currentUser === null ? 
        null
      :
        <Grid></Grid>
      }
      <Grid item xs={11} container style={{maxWidth: 1200, position:'relative', background: 'white', display: 'flex', borderRadius:'12px', outline:'none', alignSelf:'baseline', marginTop:40}}>
        <Grid id='service-side' item container xs={12} md={7} style={{padding:'5px', height:'fit-content'}}>
        
          <Grid id='image-contianer' item container xs={12} style={{height: imageHeight, position:'relative'}}>
            {/* REPLACE THIS DIV WITH THE IMAGE GALLERY */}
              {pro.images.works &&
              <Sliderr images={pro.images.works} pro={pro} userData={userData} select={select} addTop={addTop} addBottom={addBottom}/>
              
              }
              <div style={{width: 'inherit', height:'inherit', borderRadius: 16, backgroundColor:'#0000002b', position:'absolute'}}></div>

              <div id='avatar-info-container' style={{position:'absolute', height: infoHeight, width:'inherit', display:'flex', justifyContent:'space-between', alignItems:'center', padding: 16}}>
                  {(width === 'xs') ? 
                  null
                :
                <>
                <Grid item container xs={9} style={{display:'flex', flexFlow:'row'}}>
                  <Avatar src={pro.images.avatar} style={{height: avatarSize, width: avatarSize, border: '2px solid white', marginRight:5}}></Avatar>
                  <div style={{display:'flex', flexFlow:'column', justifyContent:'center', overflow:'hidden'}}>
                      {pro.showDisplay !== undefined && pro.displayName !== undefined && pro.showDisplay === false ?
                        <Typography style={{fontWeight:'bold', fontSize:h2, color: 'white', lineHeight:0, marginBottom:h2}}>{pro.firstName+' '+pro.lastName}</Typography>
                      :
                        <Typography style={{fontWeight:'bold', fontSize:h2, color: 'white', lineHeight:0, marginBottom:h2}}>{pro.displayName}</Typography>
                      }
                      <Typography style={{fontSize:text, color: 'white', lineHeight:0, marginBottom:h2, textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{pro.title}</Typography>
                      <Typography style={{fontWeight:'bold', fontSize:h2, color: 'white',lineHeight:0}}>{((pro.ratings.reduce(function (previousValue, currentValue) {return previousValue + currentValue.rating}, 0))/ pro.ratings.length).toFixed(2)} <span>({numOfAppts})</span></Typography>
                  </div>
                </Grid>
                <Grid item container xs={3} style={{display:'flex', justifyContent:'flex-end'}}>
                  
                  {(userData.userId === pro.userId) ?
                  <IconButton onClick={handleEditAcctModal}><EditIcon style={{color:'white'}}/></IconButton>
                  :
                  <CopyToClipboard text={`http://bizzybook.app/pro/profile/${pro.url}`} onCopy={handleClick(TransitionUp)}>
                    <IconButton><ShareIcon style={{color:'white'}}/></IconButton>
                  </CopyToClipboard>
                  }

                  {(userData.userId === pro.userId) ?
                    <IconButton onClick={handleOpenBizCard}><img src="https://img.icons8.com/fluency-systems-regular/24/ffffff/qr-code--v1.png" alt=''/></IconButton>
                  :
                  (currentUser === null) ?
                  <IconButton onClick={()=> setShowLoginModal(true)}><FavoriteBorderIcon style={{color:'white'}}/></IconButton>
                  :
                  (userData.favorites && userData.favorites.includes(pro.email)) ?
                  <IconButton onClick={handleRemoveFavorite}><FavoriteIcon style={{color:'red'}}/></IconButton>
                  :
                  <IconButton onClick={handleAddFavorite}><FavoriteBorderIcon style={{color:'white'}}/></IconButton>
                  }
                  
                </Grid>
                {!!pro.online &&
                <div style={{position:'absolute', top:onlineTop, left:onlineLeft, height:15, width:15, borderRadius:15, backgroundColor:'green', border: '2px solid white'}}></div>
                }
                </>
                }
              </div>

              {/* SHOW ONLY IF PROFILE BELONGS TO CURRENT USER */}
              {(userData.userId === pro.userId) &&
              <div></div>
              }

              <input style={{display: 'none'}}
                type="file"
                id="image"
                name="image"
                // onChange={onChange}
                onChange={onFileChange}
                ref={fileInput}
                accept=".gif,.jpg,.jpeg,.png"
                />
          </Grid>

          <Grid item container xs={12} style={{display:'flex', flexFlow:'row', justifyContent:'space-between', margin: '10px 0px'}}>
            <Grid item container xs={6}>
              {pro.travel === true &&
                <>
                <DriveEtaIcon style={{height:h2, width:h2, marginRight:4}}/>
                <Typography style={{fontSize:text}}>Mobile Service Provider</Typography>
                </>
              }
            </Grid>

            <Grid item container xs={6} style={{display:'flex', justifyContent:'flex-end'}}>
              {(pro.online === true && pro.busy === false) &&
                <Typography style={{color:'green', fontSize:text}}>(ONLINE & AVAILABLE NOW)</Typography>
              }
              {(pro.online === true && pro.busy === true) &&
                <Typography style={{color:'green', fontSize:text}}>(ONLINE NOW)</Typography>

              }
            </Grid>
          </Grid>

          {width === 'xs' ?
          <Grid item container xs={12} style={{position:'relative'}}>
            <Grid item container xs={9} style={{display:'flex', flexFlow:'row'}}>
              <Avatar src={pro.images.avatar} style={{height: avatarSize, width: avatarSize, border: '2px solid white', marginRight:5}}></Avatar>
              <div style={{display:'flex', flexFlow:'column', justifyContent:'center', overflow:'hidden'}}>
                  <Typography style={{fontWeight:'bold', fontSize:h2, lineHeight:0, marginBottom:h2}}>{pro.firstName+' '+pro.lastName.charAt(0)}</Typography>
                  <Typography style={{fontSize:text, lineHeight:0, marginBottom:h2, textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{pro.title}</Typography>
                  <Typography style={{fontWeight:'bold', fontSize:h2,lineHeight:0}}>{((pro.ratings.reduce(function (previousValue, currentValue) {return previousValue + currentValue.rating}, 0))/ pro.ratings.length).toFixed(2)} <span>({numOfAppts})</span></Typography>
              </div>
            </Grid>

            <Grid item container xs={3} style={{display:'flex', justifyContent:'flex-end', alignItems:'center'}}>
              {(userData.userId === pro.userId) ?
               <IconButton style={{width:30, height:30}} onClick={handleEditAcctModal}><EditIcon/></IconButton>
              :
              <CopyToClipboard text={`http://bizzybook.app/pro/profile/${pro.url}`} onCopy={handleClick(TransitionUp)}>
                <IconButton style={{width:30, height:30}}><ShareIcon/></IconButton>
              </CopyToClipboard>
              }
              
              {(userData.userId === pro.userId) ?
                  <IconButton style={{width:30, height:30}} onClick={handleOpenBizCard}><img src="https://img.icons8.com/fluency-systems-regular/24/000000/qr-code--v1.png" alt=''/></IconButton>
                  :
                  (currentUser === null) ?
                  <IconButton style={{width:30, height:30}} onClick={()=> setShowLoginModal(true)}><FavoriteBorderIcon/></IconButton>
                  :
                  (userData.favorites && userData.favorites.includes(pro.email)) ?
                  <IconButton style={{width:30, height:30}} onClick={handleRemoveFavorite}><FavoriteIcon style={{color:'red'}}/></IconButton>
                  :
                  <IconButton style={{width:30, height:30}} onClick={handleAddFavorite}><FavoriteBorderIcon/></IconButton>
                  }
            </Grid>
              {!!pro.online &&
                <div style={{position:'absolute', top:45, left:45, height:15, width:15, borderRadius:15, backgroundColor:'green', border: '2px solid white'}}></div>
              }
          </Grid>  
          :
          null
          }

          <Grid item container xs={12} style={{margin:'10px 0px', paddingBottom:10, borderBottom:'1px solid lightgray'}}>
              <Grid item container xs={6}>
                <Typography style={{fontSize:h1, fontWeight:'bold'}}>Services</Typography>
              </Grid>
              <Grid item container xs={6} style={{display:'flex', justifyContent:'flex-end'}}>
                <Paper component='form' style={{border:'2px solid lightgray', borderRadius: 20, height: 40 , width: 'inherit', paddingTop: 2, display:'flex', alignItems:'center', boxShadow: 'none'}}
                  className={classes.inputField}>    
                    <SearchIcon className={classes.icon} style={{color:'lightgrey', cursor:'pointer'}}/>
                    <InputBase
                      name='search'
                      value={serviceSearch}
                      onChange={(e) => {setServiceSearch(e.target.value)}}
                      placeholder="Search..."
                      className={classes.input}
                      style={{flex:'1 1 auto', padding:' 0px 10px'}}
                      //autoFocus
                      />  
                </Paper>
              </Grid>
          </Grid>

          <Grid item container xs={12} style={{margin:'10px 0px', paddingBottom:10, borderBottom:'1px solid lightgray'}}>

            {services.length !== 0
            && services.filter((service)=> service.addOn !== null && service.addOn !== true).
            sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() && 1 || -1).filter((service) => {
              const name = service.name
              if(serviceSearch === '') {
                  return service
                  } else if (name.toLowerCase().includes(serviceSearch.toLowerCase())) {
                      return service
                  }
                  }).map((service, idx) => {
                    const {name, price, serviceType, time} = service
                      return(<ServiceCard key={idx} userData={userData} service={service} size={size} name={name} price={price} serviceType={serviceType} time={time} pro={pro} selectedService={selectedService} setSelectedService={setSelectedService} handleBookingModalOpen={handleBookingModalOpen} authModal={showLoginModal} setShowLogin={setShowLoginModal} handleAuthModal={handleCloseModal}/>)
                  }).sort()  
          }
          </Grid>

        </Grid>


        <Grid id='info-side' item container xs={12} md={5} style={{padding:'5px', height:'fit-content'}}>

          <Grid item container xs={12}>
            <Typography style={{fontSize:h1, fontWeight:'bold'}}>About</Typography>
          </Grid>

            <Grid item container xs={12} style={{paddingBottom:10, borderBottom:'1px solid lightgray', display:'flex', justifyContent:'center'}}>
            <Typography variant='subtitle1' style={{maxHeight:220, overflowY:'scroll', width:'100%', whiteSpace:'pre-line'}}>{pro.bio}</Typography>
            <Typography style={{width:'100%', textAlign:'center', marginTop:20, fontWeight:'bold'}}>Contact Info:</Typography>
            
          {currentUser !== null ?
            <Grid item container xs={12} style={{display:'flex', flexFlow:'row', justifyContent:'space-around', padding:padding, margin:'20px 0px'}}>
              {pro.socialMedia.facebook !=="" && 
              <Avatar className={classes.contactAv} onClick={()=> window.open(`${pro.socialMedia.facebook}`)}><img src="https://img.icons8.com/fluency/48/000000/facebook-new.png" alt='fb'/></Avatar>   
              }

              {pro.socialMedia.instagram  !=="" && 
              <Avatar className={classes.contactAv} onClick={()=> window.open(`${pro.socialMedia.instagram}`)}><img src="https://img.icons8.com/fluency/48/000000/instagram-new.png" alt="insta"/></Avatar>
              }

              {pro.socialMedia.twitter !=="" && 
              <Avatar className={classes.contactAv} onClick={()=> window.open(`${pro.socialMedia.twitter}`)}><img src="https://img.icons8.com/color/48/000000/twitter-circled--v1.png" alt="twitter"/></Avatar>
              }

              {pro.socialMedia.tiktok !=="" && 
              <Avatar className={classes.contactAv} onClick={()=> window.open(`${pro.socialMedia.tiktok}`)}><img src="https://img.icons8.com/color/48/000000/tiktok--v1.png" alt="tiktok"/></Avatar>
              }

              {pro.showPhone && 
              <CopyToClipboard text={pro.email} onCopy={handleClick(TransitionUp)}>
                <Avatar className={classes.contactAv}><MailOutlineIcon/></Avatar>
              </CopyToClipboard>
              }

              {pro.showEmail &&
              <CopyToClipboard text={pro.phone} onCopy={handleClick(TransitionUp)}>
                <Avatar className={classes.contactAv}><PhoneIcon/></Avatar>
              </CopyToClipboard>
              }

            </Grid>
            :
            <Grid item container xs={12} style={{paddingBottom:10, borderBottom:'1px solid lightgray', display:'flex', justifyContent:'center'}}>
              <Typography style={{fontSize:14, color:'lightgray', marginBottom:20}}><em>Please sign in to reveal contact info</em></Typography>
            </Grid>
            }
            
            {(userData.userId === pro.userId) &&
              <Button variant='contained' color='primary' style={{marginBottom:20}} onClick={handleEditSMModal}>Edit</Button>
            }
          </Grid>


          {!!pro.showAddress &&
          <Grid item container xs={12}>
            <Typography style={{fontSize:h1, fontWeight:'bold'}}>Location</Typography>
          </Grid>
          }

          {!!pro.showAddress &&
          <Grid item container xs={12} style={{paddingBottom:10, borderBottom:'1px solid lightgray', textAlign:'center'}}>
            <Typography variant='subtitle1' style={{maxHeight:220, width:'100%'}}>{pro.address}</Typography>
          </Grid>
          }

          <Grid item container xs={12}>
            <Typography style={{fontSize:h1, fontWeight:'bold'}}>Availability</Typography>
          </Grid>

          <Grid item container xs={12} style={{padding:10, borderBottom:'1px solid lightgray', display:'flex', justifyContent:'center',}}>
            {pro.availability &&
              <Grid item contianer xs={12} sm={8} style={{height:200, display:'flex', flexFlow:'column'}}>
                  {pro.availability.sort(function sortByDay(a,b) {
                    let day1 = a.day.toLowerCase()
                    let day2 = b.day.toLowerCase()
                    return sorter[day1] - sorter[day2]
                  }).map((i, idx) => {
                    function formatAMPM(time) {
                      var hours = time.split(':')[0];
                      var minutes = time.split(':')[1];
                      var ampm = hours >= 12 ? 'PM' : 'AM';
                      hours = hours % 12;
                      hours = hours ? hours : 12; // the hour '0' should be '12'
                      minutes = minutes < 10 ? minutes : minutes;
                      var strTime = hours + ':' + minutes + ' ' + ampm;
                      return strTime;
                      }
                    switch (i.day) {
                      case 'mon':
                        return (
                          <Grid item container xs={12}>
                            <Grid item xs={4}>
                              <Typography>Mon:</Typography>
                            </Grid>
                            <Grid item xs={8} style={{display:'flex', justifyContent:'flex-end'}}>
                              <Typography>{i.slots.length > 0 ? formatAMPM(i.slots[0].from)+ " - " + formatAMPM(i.slots[i.slots.length-1].to) : 'CLOSED'}</Typography>
                            </Grid>
                          </Grid>
                        )                    
                      case 'tue':
                        return (
                          <Grid item container xs={12}>
                            <Grid item xs={4}>
                              <Typography>Tue:</Typography>
                            </Grid>
                            <Grid item xs={8} style={{display:'flex', justifyContent:'flex-end'}}>
                              <Typography>{i.slots.length > 0 ? formatAMPM(i.slots[0].from)+ " - " + formatAMPM(i.slots[i.slots.length-1].to) : 'CLOSED'}</Typography>
                            </Grid>
                          </Grid>
                        )                    
                      case 'wed':
                        return (
                          <Grid item container xs={12}>
                            <Grid item xs={4}>
                              <Typography>Wed:</Typography>
                            </Grid>
                            <Grid item xs={8} style={{display:'flex', justifyContent:'flex-end'}}>
                              <Typography>{i.slots.length > 0 ? formatAMPM(i.slots[0].from)+ " - " + formatAMPM(i.slots[i.slots.length-1].to) : 'CLOSED'}</Typography>
                            </Grid>
                          </Grid>
                        )                    
                      case 'thu':
                        return (
                          <Grid item container xs={12}>
                            <Grid item xs={4}>
                              <Typography>Thu:</Typography>
                            </Grid>
                            <Grid item xs={8} style={{display:'flex', justifyContent:'flex-end'}}>
                              <Typography>{i.slots.length > 0 ? formatAMPM(i.slots[0].from)+ " - " + formatAMPM(i.slots[i.slots.length-1].to) : 'CLOSED'}</Typography>
                            </Grid>
                          </Grid>
                        )                    
                      case 'fri':
                        return (
                          <Grid item container xs={12}>
                            <Grid item xs={4}>
                              <Typography>Fri:</Typography>
                            </Grid>
                            <Grid item xs={8} style={{display:'flex', justifyContent:'flex-end'}}>
                              <Typography>{i.slots.length > 0 ? formatAMPM(i.slots[0].from)+ " - " + formatAMPM(i.slots[i.slots.length-1].to) : 'CLOSED'}</Typography>
                            </Grid>
                          </Grid>
                        )                    
                      case 'sat':
                        return (
                          <Grid item container xs={12}>
                            <Grid item xs={4}>
                              <Typography>Sat:</Typography>
                            </Grid>
                            <Grid item xs={8} style={{display:'flex', justifyContent:'flex-end'}}>
                              <Typography>{i.slots.length > 0 ? formatAMPM(i.slots[0].from)+ " - " + formatAMPM(i.slots[i.slots.length-1].to) : 'CLOSED'}</Typography>
                            </Grid>
                          </Grid>
                        )                    
                      case 'sun':
                        return (
                          <Grid item container xs={12}>
                            <Grid item xs={4}>
                              <Typography>Sun:</Typography>
                            </Grid>
                            <Grid item xs={8} style={{display:'flex', justifyContent:'flex-end'}}>
                              <Typography>{i.slots.length > 0 ? formatAMPM(i.slots[0].from)+ " - " + formatAMPM(i.slots[i.slots.length-1].to) : 'CLOSED'}</Typography>
                            </Grid>
                          </Grid>
                        )                    
                      default:
                        break;
                    }
                  })
                  }
              </Grid>
            }

            <Grid item container xs={12} style={{display:'flex', justifyContent:'center'}}>
              {/* DISABLE IF PROFILE BELONGS TO CURRENT USER */}
              {((userData.userId !== pro.userId) && currentUser !== null) ?
                // <Button onClick={() => {handleOpenSchedule()}} style={{backgroundColor:'#413e68', color:'white', width:'fit-content', margin:'20px 0px'}}><EventAvailableIcon style={{marginRight: 10}}/>Book {pro.firstName}</Button>
                null
                :
                (currentUser === null) ?
                <Button onClick={()=> setShowLoginModal(true)} style={{backgroundColor:'#413e68', color:'white', width:'fit-content', margin:'20px 0px'}}><EventAvailableIcon style={{marginRight: 10}}/>Book {pro.firstName}</Button>
                :
                <Button variant='contained' color='primary' style={{width:'fit-content', margin:'20px 0px'}} onClick={() => history.push('/settings/availability')}>Edit</Button>
              }
            </Grid>
          </Grid>

          <Grid item container xs={12}>
            <Typography style={{fontSize:h1, fontWeight:'bold'}}>Reviews</Typography>

            <Grid item containter xs={12} style={{borderRadius:12, margin:10, height:150, border:'1px solid lightgray', display:'flex'}}>
              <Grid container item xs={6} style={{borderRight:'1px solid lightgray', height:'inherit', display:'flex', alignItems:'center'}}>
                <div style={{width:'inherit', height:'fit-contnet', display:'flex', flexFlow:'inherit', justifyContent:'center'}}>
                  <Typography style={{width:'100%', textAlign:'center'}}><span style={{fontSize:30, fontWeight:'bold'}}>{((pro.ratings.reduce(function (previousValue, currentValue) {return previousValue + currentValue.rating}, 0))/ pro.ratings.length).toFixed(2)}</span>/5</Typography>
                  {[...Array(5)].map((star,idx) => {
                          return <StarIcon style={{color: '#413e68', fontSize:24}} className={classes.button}/>       
                          })
                  }
                  <Typography style={{color:'gray', fontSize:12, width:'100%', textAlign:'center'}}>{reviews.length} reviews</Typography>  
                </div>
              </Grid>
              <Grid container item xs={6} style={{height:'inherit', display:'flex', flexFlow:'inherit', justifyContent:'center'}}>
                  <ul style={{paddingLeft:0, listStyleType:'none'}}>
                    {[...Array(5)].map((num, idx) => {
                        return <li style={{display:'flex', alignItems:'center'}}>
                          <Typography style={{textAlign:'right', width:50}}>{5 - idx} <StarIcon style={{color: '#413e68', verticalAlign:'middle', marginRight:10, fontSize:14}}/></Typography>
                          <div style={{width:barWidth, height:4, backgroundColor:'lightgray', display:'flex'}}>
                            {reviews.length > 0 &&
                              <div style={{width:`${(reviews.filter(r => r.review.rating === (5 - idx)).length / reviews.length * 100).toFixed(2)}%`, backgroundColor:'#413e68'}}></div>
                            }
                          </div>
                          <Typography style={{marginLeft:10, color:'gray', fontSize:14}}>{pro.ratings.filter(r => r.rating === (5 - idx)).length}</Typography>
                          </li>
                    })}
                  </ul>
              </Grid>

            </Grid>

            {reviews.length > 0 ?
              reviews.map((rev, idx) => {
                const {review} = rev
                return (
                <Grid item xs={12} style={{padding:10, display:'flex', borderBottom:'1px solid lightgray'}}>
                  <Grid item container style={{flex:'0 1 40px'}}>
                    <Avatar src={review.avatar}></Avatar>
                  </Grid>
                  <Grid item style={{flex:'1 0 80%', paddingLeft:5}}>
                    <Typography style={{width:'100%', fontWeight:'bold', display:'flex', alignItems:'center'}}>{review.name} <span style={{fontWeight:'normal', fontSize:12, color: 'gray', marginLeft:5}}>({review.service})</span></Typography>
                    {[...Array(review.rating)].map((star,idx) => {
                        return <StarIcon style={{color: '#413e68', fontSize:16}} className={classes.button}/>       
                        })
                    }
                    <Typography style={{width:'100%'}}>{review.feedback}</Typography>
                  </Grid>
                </Grid>
                )
              })
              :
              <Typography style={{fontSize:14, color:'lightgray', marginBottom:20}}><em>No Reviews yet...</em></Typography>
            }


          </Grid>

          <Grid item container xs={12} style={{paddingBottom:10, borderBottom:'1px solid lightgray'}}>

          </Grid>

          <Grid className={classes.section} onClick={handleCancelationModal} item container xs={12} style={{display:'flex', justifyContent:'space-between', borderBottom:'1px solid lightgray', alignItems:'center'}}>
            <Typography style={{fontSize:text, padding:'10px 0px'}}>Cancelation Policy</Typography>
            <IconButton>
              <ArrowBackIos style={{transform:'rotate(180deg)'}}/>
            </IconButton>
          </Grid>

          <Grid className={classes.section} onClick={handleReportModalOpen} item container xs={12} style={{display:'flex', justifyContent:'space-between', borderBottom:'1px solid lightgray', alignItems:'center'}}>
            <Typography style={{fontSize:text, padding:'10px 0px'}}>Report Abuse</Typography>
            <IconButton>
              <ArrowBackIos style={{transform:'rotate(180deg)'}}/>
            </IconButton>
          </Grid>
          
        </Grid>

      </Grid>

    {currentUser === null ? 
        null
      :
        <Grid></Grid>
      }

      <EditAccountModal modalOpen={editAcctModalOpen} userData={pro} setModalOpen={setEditAcctModalOpen}/>
      
      <EditSocialMediaModal modalOpen={editSMModalOpen} userData={pro} setModalOpen={setEditSMModalOpen}/>

      <Modal open={!!imageModalOpen}>
              
        <Grid container item style={{height:size, width:size, position:'absolute', top:'50%', left:'50%', transform:'translate(-50%, -50%)', display:'flex', justifyContent:'center'}}> 
              <img src={openedImage} alt={openedImage} style={{objectFit:'cover', objectPosition:'center', width:'100%', height:'100%'}}/>
        
            <IconButton onClick={handleCloseImage} style={{position:'absolute', top:'-18px', right:0, backgroundColor:'#ffffff94'}}><HighlightOffIcon/></IconButton>
        </Grid>

    </Modal>

    <ReportModal open={reportModalOpen} handleOpen={handleReportModalOpen} pro={pro}/>

    <BusinessCardModal handleOpenBizCard={handleOpenBizCard} bcModalOpen={bcModalOpen} pro={pro}/>
    
    <ScheduleProModal handleOpenSchedule={handleOpenSchedule} scheduleOpen={scheduleOpen} pro={pro}/>

      <Snackbar open={openSuccess} autoHideDuration={2000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity[1]}>
              Your Image Was Uploaded Successfully!
          </Alert>
      </Snackbar>
      <Snackbar open={openErr} autoHideDuration={2000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity[0]}>
          Oops, something went wrong...
          </Alert>
      </Snackbar>
      
      </Grid>
      }

      <Modal
          open={showLoginModal}
          onClose={handleCloseModal}>
          <LoginModal/>
      </Modal>

      <Modal open={imageSrc !== null} onClose={closeModal}>
              <Grid container item xs={10} sm={6}
                style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%, -50%)', backgroundColor: 'white', borderRadius: '15px', padding:'30px', display:'flex', flexFlow:'column', justifyContent:'center', alignItems:'center', outline:'none',  maxHeight:'90%'}}>
                    <div style={{width:'inherit', height:'inherit', position:'relative'}}>
                      <div className={classes.cropContainer}>
                        <Cropper
                          image={imageSrc}
                          crop={crop}
                          rotation={rotation}
                          zoom={zoom}
                          aspect={16 / 10}
                          onCropChange={setCrop}
                          onRotationChange={setRotation}
                          onCropComplete={onCropComplete}
                          onZoomChange={setZoom}
                        />
                      </div>
                    </div>
                    <div className={classes.controls}>
                      <div className={classes.sliderContainer}>
                        <Typography
                          variant="overline"
                          classes={{ root: classes.sliderLabel }}
                        >
                          Zoom
                        </Typography>
                        <Slider
                          value={zoom}
                          min={1}
                          max={3}
                          step={0.1}
                          aria-labelledby="Zoom"
                          classes={{ root: classes.slider }}
                          onChange={(e, zoom) => setZoom(zoom)}
                        />
                      </div>
                      <div className={classes.sliderContainer}>
                        <Typography
                          variant="overline"
                          classes={{ root: classes.sliderLabel }}
                        >
                          Rotation
                        </Typography>
                        <Slider
                          value={rotation}
                          min={0}
                          max={360}
                          step={1}
                          aria-labelledby="Rotation"
                          classes={{ root: classes.slider }}
                          onChange={(e, rotation) => setRotation(rotation)}
                        />
                      </div>
                    </div>
                      <Grid item container xs={12} style={{display:'flex', justifyContent:'space-evenly'}}>
                        <Button variant='contained' color='secondary' style={{fontWeight:'bold', marginTop:20}} onClick={closeModal}>Cancel</Button>
                        {imageLoading === false ?
                        <Button variant='contained' color='primary' style={{fontWeight:'bold', marginTop:20}} 
                        // onClick={()=>uploadImg(previewCanvasRef.current, croppedAreaPixels)}
                        onClick={uploadCroppedImage}
                        >Upload</Button>
                        :
                        <div className={classes.wrapper}>
                        <Button variant='contained' color='primary' style={{fontWeight:'bold', marginTop:20}} disabled>Uploading...</Button>
                        <CircularProgress size={24} className={classes.buttonProgress} />
                      </div> 
                        }

                      </Grid>

                </Grid>

      </Modal>

	  <Modal open={!!cancelationModal} onClose={handleCancelationModal}>
	  	<Grid container item xs={11} md={5} lg={4} display='column' style={{display:'flex', outline:'none', position:'absolute', left:'50%', top:'50%', transform:'translate(-50%, -50%)', backgroundColor: 'white', padding: '10px', borderRadius: '15px'}}>
		  <Grid container item xs={12} style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
				<Typography component="h1" variant="h5">
					Cancelation Policy
				</Typography>
				<IconButton onClick={handleCancelationModal}><Close/></IconButton>
			</Grid>

			<Grid container item xs={12}>

				{!editCancelation ?
					<Typography style={{maxHeight:250, overflowY:'scroll', width:'100%', whiteSpace:'pre-line', padding:10}}>{(pro.cancelationPolicy && pro.cancelationPolicy!=='') ? pro.cancelationPolicy : "Cancellation of Appointments. You may cancel any appointment in accordance with our cancellation policy set forth at [INSERT URL]. We reserve the right to cancel free promotional Services at any time for any reason. No credits or promotional value adjustments will be made in the event we cancel a free promotional Service. If the service provider cancels an appointment for any reason, you will receive a refund, unless you are at fault for the delay/cancelation of the service. If service providers cancel or terminate a paid appointment for any reason, we may, in our sole and reasonable discretion, issue you a refund of any fees/deposits prepaid for such appointment with the exception of the Service Fee. All service fees are non refundable.\n\n Supplemental COVID-19 Cancellation Policy. In addition to the cancellation rights set forth in the BizzyBook cancellation policy set forth at [INSERT URL], you must cancel an appointment through the Services if you have a cough, fever or other symptoms of COVID-19, if you have tested positive or COVID-19, or if you generally feel unwell and may do so at any time until 1 hour before the start time of the appointment without any penalty. BizzyBook reserves the right to revise or update this supplemental cancellation policy at any time, including to cover other pandemics or illnesses.\n\nBoth clients and service providers should also be aware that the other party to an appointment is required to cancel the appointment in accordance with this Supplemental COVID-19 Cancellation Policy and may do so at any time. BizzyBook cannot guarantee replacements for such cancellations and does not take any responsibility or liability for, or in connection with, any cancelled appointments or any results thereof.\n\nIf BizzyBook discovers that you, whether a client or a service provider, has abused this supplemental cancellation policy, BizzyBook has the right to, immediately, without notice, and in its sole discretion, suspend or terminate your Account."}
					</Typography>
					:
					<TextareaAutosize placeholder='To use standard cancelation policy, leave this section blank.' style={{width:'100%', height:250}} defaultValue={pro.cancelationPolicy ? pro.cancelationPolicy : cancelationPolicy} onChange={(e)=> setCancelationPolicy(e.target.value)}/>
				}

				<Grid container xs={12} >
				{userData.userId === pro.userId &&
				<Button variant='contained' color='secondary' onClick={handleEditCP}>Edit</Button>
				}

				{editCancelation &&
				<Button variant='contained' color='primary' style={{marginLeft:10}} onClick={handleSaveCP}>Save</Button>
				}

			</Grid>

			</Grid>

		</Grid>
	  </Modal>

      <Snackbar
              open={copied}
              onClose={handleClose}
              TransitionComponent={transition}
              message="Copied to cliptrap."
              key={transition ? transition.name : ''}
          />

      <BookAppointmentModal pro={pro} selectedService={selectedService} setSelectedService={setSelectedService} userData={userData} modalOpen={bookingModalOpen} handleBookingModalOpen={handleBookingModalOpen}/>

      </>
  )
}

ProProfile.propTypes = {
  width: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']).isRequired,
};

function readFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => resolve(reader.result), false)
    reader.readAsDataURL(file)
  })
}

export default withWidth()(ProProfile)

